import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loadingSearch: false,
  },
  mutations: {
    setLoadingSearch(state, payload) {
      state.loadingSearch = payload;
    },
  },
  actions: {
    setLoadingSearch({ commit }, payload) {
      commit("setLoadingSearch", payload);
    },
  },
  getters: {
    loadingSearch(state) {
      return state.loadingSearch;
    },
  },
  modules: {},
});
